// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
.ws-review-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ededed;
}
.ws-review-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
}
.ws-review-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  border-radius: 999px;
  border: 1px solid #ededed;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.ws-review-back:hover:not(:disabled) {
  background: #fafafa;
  border-color: #005ff0;
}
.ws-review-back:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.ws-loading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6c757d;
}
.ws-progress {
  font-weight: 600;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/wizard-stream-phase.component.less"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AAAF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AADF;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAFF;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AAHF;AAKE;EACE,mBAAA;EACA,qBAAA;AAHJ;AAME;EAAa,aAAA;EAAe,mBAAA;AAF9B;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAHF;AAMA;EACE,gBAAA;EACA,SAAA;AAJF","sourcesContent":["// Wizard stream phase only (not shared with Argyle income modals).\n:host {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.ws-review-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ededed;\n}\n\n.ws-review-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #171717;\n}\n\n.ws-review-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 14px;\n  border-radius: 999px;\n  border: 1px solid #ededed;\n  background: #fff;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #005ff0;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n\n  &:hover:not(:disabled) {\n    background: #fafafa;\n    border-color: #005ff0;\n  }\n\n  &:disabled { opacity: 0.45; cursor: not-allowed; }\n}\n\n.ws-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #6c757d;\n}\n\n.ws-progress {\n  font-weight: 600;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
